import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetCartNotes = createChainHandler("SetCartNotes", chain, props => {
    if (props.apiParameter.cart && !props.apiParameter.cart.notes) {
        props.apiParameter.cart.notes = props.getState().pages.checkoutShipping.editedCartNotes ?? "";
    }
});

addToChainAfter(chain, PopulateApiParameter, SetCartNotes);
